
const $47b0502f1efab1e0$var$questions = [
    {
        question: "What year Did Book Banning Begin?",
        answers: [
            "1",
            "2",
            "3",
            "4"
        ],
        correct: "1"
    },
    {
        question: "What is an organization that is against book banning?",
        answers: [
            "1",
            "3",
            "7",
            "2"
        ],
        correct: "1"
    },
    {
        question: "Which State has the most Book bans?",
        answers: [
            "1",
            "2",
            "3",
            "4"
        ],
        correct: "1"
    },
    {
        question: "Which State has the least book bans?",
        answers: [
            "1",
            "2",
            "3",
            "4"
        ],
        correct: "1"
    },
    {
        question: "What year had the most book bans?",
        answers: [
            "1",
            "2",
            "3",
            "4"
        ],
        correct: "1"
    }
];
//DOM grabbing HTML
const $47b0502f1efab1e0$var$questionElement = document.getElementById("questions");
const $47b0502f1efab1e0$var$answerButtons = document.getElementById("answers");
const $47b0502f1efab1e0$var$scoreContainer = document.getElementById("score-container");
const $47b0502f1efab1e0$var$finalScore = document.getElementById("final-score");
const $47b0502f1efab1e0$var$restartButton = document.getElementById("restart");
//Quiz variables
let $47b0502f1efab1e0$var$currentQuestionIndex = 0; //Starts at first question
let $47b0502f1efab1e0$var$score = 0; //Starts the score at 0
//Start quiz
function $47b0502f1efab1e0$var$startQuiz() {
    $47b0502f1efab1e0$var$currentQuestionIndex = 0;
    $47b0502f1efab1e0$var$score = 0;
    $47b0502f1efab1e0$var$finalScore.textcontent = "";
    $47b0502f1efab1e0$var$scoreContainer.classList.add("hidden");
    // Call the function that will show the question
    $47b0502f1efab1e0$var$showQuestion();
}
//Show the quesiton
function $47b0502f1efab1e0$var$showQuestion() {
    const currentQuestion = $47b0502f1efab1e0$var$questions[$47b0502f1efab1e0$var$currentQuestionIndex];
    $47b0502f1efab1e0$var$questionElement.textcontent = currentQuestion.question;
    currentQuestion.answers.forEach((answer)=>{});
}


//# sourceMappingURL=quiz.23b92aa5.js.map
